import React from 'react';
import { Table, Icon, Menu, Dropdown } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import _ from 'underscore';
import Moment from 'moment';
import { withRouter } from 'react-router';

const SysadminClientListTable = (props) => {
    const paginationInfo = `${(props.perPage*props.currentPage)-props.perPage+1}-${(props.perPage*props.currentPage)>props.totalData ? props.totalData : (props.perPage*props.currentPage)} of ${props.totalData}`
    return (
        <Table celled selectable>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell>ID</Table.HeaderCell>
                    <Table.HeaderCell>Company Name</Table.HeaderCell>
                    <Table.HeaderCell>Status</Table.HeaderCell>
                    <Table.HeaderCell>Group Code</Table.HeaderCell>
                    <Table.HeaderCell>Created</Table.HeaderCell>
                    <Table.HeaderCell>Updated</Table.HeaderCell>
                    <Table.HeaderCell>Users</Table.HeaderCell>
                </Table.Row>
            </Table.Header>
            <Table.Body>
                {
                    _.map(props.clients, (client) => {
                        const {
                            _id,
                            name,
                            status,
                            groupCode,
                            created,
                            updated
                        } = client;
                        return (
                            <Table.Row key={_id}>
                                <Table.Cell>
                                    <Link to={`/systemadmin/client/${_id}/update`}>
                                        {_id}
                                    </Link>
                                </Table.Cell>
                                <Table.Cell>{name}</Table.Cell>
                                <Table.Cell>{status}</Table.Cell>
                                <Table.Cell>{groupCode}</Table.Cell>
                                <Table.Cell>{Moment(created).format('DD/MM/YYYY')}</Table.Cell>
                                <Table.Cell>{Moment(updated).format('DD/MM/YYYY')}</Table.Cell>
                                <Table.Cell>
                                    <Link to={`/systemadmin/client/${_id}/users?page=1&v=10`}>Users</Link>
                                </Table.Cell>
                            </Table.Row>
                        );
                    })
                }
            </Table.Body>
            <Table.Footer>
                <Table.Row>
                    <Table.HeaderCell colSpan='8'>
                        <Menu floated='right' pagination>
                            <Menu.Item as='a' icon onClick={props.goToPreviousPage}
                                disabled={props.currentPage === 1}>
                                <Icon name='chevron left'/>
                            </Menu.Item>
                            <Menu.Item>{paginationInfo}</Menu.Item>
                            <Menu.Item as='a' icon onClick={props.goToNextPage}
                                disabled={!props.isShowNextButton}>
                                <Icon name='chevron right'/>
                            </Menu.Item>
                        </Menu>
                        <Menu floated='right' pagination>
                            <Menu.Item>Page</Menu.Item>
                            <Dropdown scrolling item text={props.currentPage.toString()} defaultValue={props.currentPage}>
                                <Dropdown.Menu>
                                    {[...Array(props.totalPage)].map((e, i) =>
                                        <Dropdown.Item key={i} onClick={() => props.setPage(i+1)}>{i+1}</Dropdown.Item>
                                    )}
                                </Dropdown.Menu>
                            </Dropdown>
                        </Menu>
                        <Menu floated='right' pagination>
                            <Menu.Item>View</Menu.Item>
                            <Dropdown item text={props.perPage.toString()} defaultValue={props.perPage}>
                                <Dropdown.Menu>
                                    <Dropdown.Item onClick={() => props.setPerPage(10)}>10</Dropdown.Item>
                                    <Dropdown.Item onClick={() => props.setPerPage(20)}>20</Dropdown.Item>
                                    <Dropdown.Item onClick={() => props.setPerPage(50)}>50</Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Menu>
                    </Table.HeaderCell>
                </Table.Row>
            </Table.Footer>
        </Table>
    );
}

export default withRouter(SysadminClientListTable);